import React, { useEffect, useId, useState } from "react";
import { X } from "lucide-react";

export function ActionPromptModal({
  open,
  title,
  label,
  placeholder = "",
  initialValue = "",
  confirmLabel = "Save",
  helperText = "",
  multiline = true,
  busy = false,
  onCancel,
  onConfirm,
}) {
  const inputId = useId();
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (open) setValue(initialValue ?? "");
  }, [open, initialValue]);

  if (!open) return null;

  const submit = (e) => {
    e.preventDefault();
    onConfirm(value);
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-md p-6 shadow-xl">
        <div className="flex items-start justify-between gap-4 mb-4">
          <div>
            <h3 className="font-bold text-mg-navy text-lg">{title}</h3>
            {helperText && <p className="text-sm text-slate-600 mt-1">{helperText}</p>}
          </div>
          <button type="button" onClick={onCancel} className="text-slate-400 hover:text-slate-700" data-testid="prompt-close">
            <X className="w-5 h-5" />
          </button>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label htmlFor={inputId} className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-1 block">
              {label}
            </label>
            {multiline ? (
              <textarea
                id={inputId}
                className="mg-input w-full min-h-28"
                placeholder={placeholder}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                data-testid="prompt-value"
              />
            ) : (
              <input
                id={inputId}
                type="text"
                className="mg-input w-full"
                placeholder={placeholder}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                data-testid="prompt-value"
              />
            )}
          </div>
          <div className="flex gap-2 pt-2">
            <button type="button" onClick={onCancel} className="mg-btn-secondary flex-1 justify-center">
              Cancel
            </button>
            <button type="submit" disabled={busy} className="mg-btn-primary flex-1 justify-center" data-testid="prompt-submit">
              {busy ? "Saving…" : confirmLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
